<template>
  <image-aside-slide
    class="main-page-image-aside-slide"
    v-bind:image-src="image.image"
    v-bind:image-alt="image.alt_text"
    v-bind:preferred-image-position="preferredImagePosition"
  >
    <main-text-block
      v-bind:title="image.title"
      v-bind:text="image.description"
    ></main-text-block>
  </image-aside-slide>
</template>

<script>
import ImageAsideSlide from './utils/ImageAsideSlide'
import MainTextBlock from './main/MainTextBlock'

export default {
  name: 'MainSlideFullScreen',
  props: ['image'],
  components: {ImageAsideSlide, MainTextBlock},
  data: function () {
    return {}
  },
  computed: {
    preferredImagePosition: function () {
      if (this.image.tags.includes('aside-left')) {
        return 'left'
      } else if (this.image.tags.includes('aside-right')) {
        return 'right'
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .main-page-image-aside-slide {
    @media only print {
      page-break-after: always;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/MainSlideImageAside.vue